import { fetchSalvarFormulario } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarArquivos } from 'store/fetchActions/fetchArquivo';
import { formatterFileFrontToBack } from 'utils/formatter/arquivos';
import { formatterRequerimentoFrontToBack } from 'utils/formatter/requerimento';
import {
  ALERTA,
  MSG_SALVAR_FORMULARIO_SUCESSO,
  MSG_VERIFICAR_SPAN,
  ENUM_MODAL,
  ID_CAPTCHA,
  USER_ENTERED_CAPTCHA_CODE,
} from 'utils/consts';
import { homeContribuinte, publicRoot } from 'routes/paths';
import { fetchStatusModal, fetchNotificationApp } from 'store/fetchActions/fetchApp';

export const submitRequerimentoInput = (dadosInputs, arquivos, assuntoId) => dispatch => {
  return new Promise((resolve, reject) => {
    const captchaId = localStorage.getItem(ID_CAPTCHA);
    const userEnteredCaptchaCode = localStorage.getItem(USER_ENTERED_CAPTCHA_CODE);
    const dadosFormatados = formatterRequerimentoFrontToBack({
      ...dadosInputs,
      captchaId,
      userEnteredCaptchaCode,
      assuntoId,
    });

    dispatch(fetchSalvarFormulario(dadosFormatados))
      .then(respostaApi => {
        dispatch(submitRequerimentoArquivo(respostaApi, arquivos))
          .then(() => resolve(respostaApi))
          .catch(error => reject(error));
      })
      .catch(error => reject(error));
  });
};

export const submitRequerimentoArquivo = (respostaApi, arquivos) => dispatch => {
  return new Promise((resolve, reject) => {
    formatterFileFrontToBack(arquivos, respostaApi).then(arquivosFormatados => {
      dispatch(fetchSalvarArquivos(arquivosFormatados))
        .then(() => resolve())
        .catch(error => reject(error));
    });
  });
};

export const sucessoRequerimento = (respostaApi, history, isLogado) => dispatch => {
  const email = respostaApi?.formularioPessoa?.pessoa?.email;
  history.push(isLogado ? homeContribuinte : publicRoot);
  fetchNotificationApp(MSG_SALVAR_FORMULARIO_SUCESSO(email), MSG_VERIFICAR_SPAN, ALERTA.SUCESSO, 'bottomRight', 10);
  dispatch(fetchStatusModal(true, ENUM_MODAL.SUCESSO_REQUERIMENTO, { respostaApi }));
};
